export default function Projects() {
  const projects = [
    {
      title: 'Sentiment Classification with BERT',
      category: 'AI & NLP',
      image: 'bert.png',
      description: 'Used the SMILE Twitter dataset and fine-tuned BERT for emotion classification.',
      tag: 'NLP'
    },
    {
      title: 'COVID-19 Data Visualization',
      category: 'Data Science',
      image: 'covid.png',
      description: 'Analyzed infection/recovery trends with Python using pandas, matplotlib, seaborn.',
      tag: 'Data Vis'
    },
    {
      title: 'Power BI Sales Dashboard',
      category: 'Data Visualization',
      image: 'powerbi.png',
      description: 'Used DAX to visualize lead totals and retired leads in salesforce data.',
      tag: 'Power BI'
    },
    {
      title: 'CNN based plant disease detection using EfficientNetV25',
      category: 'Deep Learning',
      image: 'plant.png',
      description: 'Used EfficientNetV25, OpenCV, Duckduckgo to classify plant leaf images.',
      tag: 'Deep Learning'
    },
    {
      title: 'Enhanced Data Management Using Excel and VBA',
      category: 'Data',
      image: 'excel.png',
      description: 'Used VBA to populate dropdown lists, used MAOL to implement SQL to consolidate sheets.',
      tag: 'Data'
    },
    {
      title: 'Heart Disease Detection Model',
      category: 'ML',
      image: 'heart.png',
      description: 'Used Random Forest to check if Heart was lassified as diseased or not.',
      tag: 'ML'
    }
  ];

  return (
    <section className="bg-gray-100 text-gray-800 py-12 px-4" id="projects">
      <h2 className="text-3xl font-bold text-center mb-8">Projects</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
        {projects.map((proj, i) => (
          <div key={i} className="bg-white shadow-md rounded-lg p-6 hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-2">{proj.title}</h3>
            <p className="text-sm mb-4">{proj.desc}</p>
            <a
              href={proj.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline text-sm"
            >
              View Project →
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

